
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'BaseState',
  props: {
    title: {
      type: String,
      required: true
    },
    heightClass: {
      type: String,
      default: 'min-h-92 max-h-screen'
    },
    spacingClass: {
      type: String,
      default: 'p-12'
    }
  }
})
